import * as React from 'react'
import { Link, browserHistory } from 'react-router'
import { inject, observer } from 'mobx-react'
import { Routes } from '../../../../../constants/Routes'
import { CurrentCompanyStore } from '../../../../../stores/CurrentCompanyStore'
import { QuickBooksApi } from '@getgreenline/quickbooks'
import { message } from 'antd-v4'
import { BLAZE_COMPANY } from '../../../../../constants/general'

interface IProps {
  currentCompanyStore?: CurrentCompanyStore
}

@inject('currentCompanyStore')
@observer
export class QuickBooksMain extends React.Component<React.PropsWithChildren<IProps>, {}> {
  componentDidMount() {
    const company = this.props.currentCompanyStore!.company!
    if (!company.hasQuickBooksAuthToken) {
      browserHistory.push(Routes.DASHBOARD_INTEGRATIONS_QUICKBOOKS_AUTH_CONNECT(company.id))
    }
  }

  revokeAccess = async () => {
    const company = this.props.currentCompanyStore!.company!
    try {
      if (
        window.confirm(`This will disconnect ${BLAZE_COMPANY} and QuickBooks Online. Are you sure?`)
      ) {
        await QuickBooksApi.revokeQuickBooksAccounts(company.id)
        message.success('QuickBooks access has been revoked')
        browserHistory.push(Routes.DASHBOARD_INTEGRATIONS_QUICKBOOKS_AUTH_CONNECT(company.id))
      }
    } catch (error) {
      message.error('Request failed')
      console.error(error)
    }
  }

  render() {
    const company = this.props.currentCompanyStore!.company!

    return (
      <div>
        <div>
          <Link to={Routes.DASHBOARD_INTEGRATIONS_QUICKBOOKS_ONLINE_SETTINGS(company.id)}>
            <button
              className={
                'mr-2 ' +
                (window.location.pathname.includes('/main/settings')
                  ? 'btn btn-success'
                  : 'btn btn-light')
              }
            >
              Settings
            </button>
          </Link>
          <Link to={Routes.DASHBOARD_INTEGRATIONS_QUICKBOOKS_ONLINE_SYNC(company.id)}>
            <button
              className={
                window.location.pathname.includes('/main/sync')
                  ? 'btn btn-success'
                  : 'btn btn-light'
              }
            >
              Sync
            </button>
          </Link>
          <button onClick={this.revokeAccess} className='btn btn-danger ml-2'>
            Disconnect
          </button>
        </div>
        <hr />
        {this.props.children}
      </div>
    )
  }
}
